var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({class:[`icon icon--${_vm.icon}`, _vm.direction, { center: _vm.center }]},_vm.hasClickEvent ? { click: _vm.handleClick } : {}),[_c(_vm.icon,{ref:"icon",tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }